import React, { useState } from "react";
import IconShowChart from "../../Icons/Report/ShowChart";
import IconPlateTypeReport from "../../Icons/Report/PlateTypeReport";
import IconExport from "../../Icons/TopCommandPanel/Export";
import EventLogPage from "./EventLog/EventLogPage";
import Header from "../Header/Header";
import Breadcrumb from "../Header/Breadcrumb";
import HeaderButton from "../Header/HeaderButton";
import LayoutContent from "../LayoutContent";
import ReportAndSupportNavSubMenu from "./ReportAndSupportNavSubMenu";
import PlateTypeApi from '../../api/PlateTypeApi';

export default function EventLogReport() {
  const SHOW_CHART = "SHOW_CHART";
  const PLATE_TYPE_REPORT = "PLATE_TYPE_REPORT";
  const EXPORT = "EXPORT";

  const [isEventLogChartShowed, setIsEventLogChartShowed] = useState(false);
  const [eventLogTextExport, setEventLogTextExport] = useState("");

  const onClickShowChart = () => {
    setIsEventLogChartShowed(true);
  };

  const onClickPlateTypeReport = () => {
    PlateTypeApi.getPlateTypeReport();
  };

  const onClickExport = () => {
    let link = document.createElement('a');
    link.download = 'Event Log.txt';
    link.href = 'data:text/plain;charset=utf-8,' + encodeURIComponent(eventLogTextExport);
    console.log(link.href);
    link.click();
  };

  return (
    <LayoutContent>
      <LayoutContent.Header>
        <Header>
          <Breadcrumb
            items={[{ title: "Report", to: "/report-support/event-log", disabled: false }]}
          />
          <Header.RightSide>
            <HeaderButton
              id={SHOW_CHART}
              label={"Show Chart"}
              icon={<IconShowChart />}
              onClick={onClickShowChart}
            />
            ,
            <HeaderButton
              id={PLATE_TYPE_REPORT}
              label={"Plate Type Report"}
              icon={<IconPlateTypeReport />}
              onClick={onClickPlateTypeReport}
            />
            ,
            <HeaderButton
              id={EXPORT}
              label={"Export"}
              icon={<IconExport />}
              onClick={onClickExport}
            />
          </Header.RightSide>
        </Header>
      </LayoutContent.Header>
      <LayoutContent.Content>
        <EventLogPage
          setIsEventLogChartShowed={setIsEventLogChartShowed}
          isEventLogChartShowed={isEventLogChartShowed}
          setEventLogTextExport={setEventLogTextExport}
          style={{
            height: "100%",
          }}
        />
      </LayoutContent.Content>
      <LayoutContent.SubMenu>
        <ReportAndSupportNavSubMenu/>
      </LayoutContent.SubMenu>
    </LayoutContent>
  );
}
